<template>
<el-modal
  v-if="isOpen"
  @close="isOpen = false"
  ref="modal"
  close-button-align="right"
  >
  <h1>{{__('Do you want to be first with the latest')}}</h1>
  <p>{{__('and follow along on the ride?')}}</p>

  <br>

  <signup-form
    :socialMediaLinks="false"
    />
</el-modal>
</template>
<script>

import SignupForm from 'components/elements/SignupForm.vue'
import devMode from 'src/devMode.js'

import logScope from 'log-scope'
const log = logScope('SubscribeModal')

export default {
  components: { SignupForm },
  data () {
    return {
      isOpen: false,
      delay: 5 * 1000
    }
  },
  mounted () {
    const hasAlreadyPoppedUp = localStorage.getItem('rideQModalAlert')

    if (hasAlreadyPoppedUp) {
      log.debug('hasAlreadyPoppedUp', hasAlreadyPoppedUp)
      return
    }

    this.delayOpen()
    localStorage.setItem('rideQModalAlert', true)
  },
  methods: {
    delayOpen () {
      if (devMode.pauseSignupPopup === true) {
        return
      }

      setTimeout(() => {
        if (this.$store.getters.videoIsPlaying === true) {
          this.delayOpen()
          return
        }

        this.isOpen = true
      }, this.delay)
    }
  }
}
</script>
<style lang="less" scoped>
  @import '~style/variables.less';

  h1 {
    margin-top: 0px;
    font-size: 24px;
  }

</style>
